import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { QuizScreen } from '../GeneralStyles';
import QuestionPublicLink from '../../component/PublicLink/PublicLink';

const IframeContainer = styled.div`
  width: 100%;
  height: 100%; 
  max-height: 100vh;  /* Ensure max-height doesn't exceed the viewport */
  max-width: 100vw;
  padding: 0;
  margin: 0;
  overflow: hidden;   /* Prevent any overflow that may cause scrollbars */
  box-sizing: border-box;

  iframe {
    width: 100%;
    height: 100vh; /* Adjust iframe to exactly fit the viewport */
    max-height: 100vh;
    max-width: 100vw;
    border: none;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    overflow: hidden; /* Prevent iframe from causing scrollbars */
  }
`;

const CommunicatingIframe = ({ url, id, onSuccess, onFailure, theme_color, overViewPage }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const handleMessage = (event) => {
      const allowedOrigins = [
        'https://tools.vrtinnovatie.be', // Replace with your actual domain
        'http://localhost:8000',         // Include localhost for development
        'https://pruts.vrt.be:8890',
        'https://vrt.be',
        'https://edubox.vrtnws.be',
      ];

      if (!allowedOrigins.includes(event.origin)) {
        console.warn('Received message from unauthorized origin:', event.origin);
        return;
      }

      const data = event.data;
      if (data === true) {
        onSuccess();
      } else if (data === false) {
        onFailure();
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [onSuccess, onFailure]);

  return (
    <QuizScreen
      style={{ padding: '0', margin: '0', boxSizing: 'border-box', overflow: 'hidden' }} 
      bgColor={theme_color}
      bgVisible={overViewPage}
      id={id}
    >
        <QuestionPublicLink
        overViewPage={overViewPage}
        type="question"
        quiz_item_id={id}
      />
      <IframeContainer>
        <iframe
          src={url}
          title="Communicating Iframe"
          ref={iframeRef}
          allow="autoplay; encrypted-media"
        />
      </IframeContainer>
    </QuizScreen>
  );
};

export default CommunicatingIframe;
